import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col, Card, Button, Badge, Table, Dropdown, ToastContainer, Toast, Spinner } from "react-bootstrap";
import { FiChevronLeft, FiMoreVertical, FiEdit } from "react-icons/fi";
import { FaBox, FaRupeeSign } from "react-icons/fa";
import Sidebar from "../common/Sidebar";
import LoaderModal from "../common/loader";
import { deleteProductApi, getProductEditApi, updateProductStatusApi } from "./product-api";
import { ReactComponent as ProduTyIc } from "../../assets/svg/produc_ty_ics.svg";
import { ReactComponent as ProduIdIc } from "../../assets/svg/produ_id_ics.svg";
import ProductIc from "../../assets/png/productIc.png";
import moreIcon from "../../assets/svg/more_ic.svg";
import DeleteModal from "../common/deleteModel";
import { Navbar } from "../common/Navbar";
import { useGlobal } from "../../GlobalContext";

const ProductView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(permission) {
    return rolePermissionList.findIndex((element) => element["name"] === "Product" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }

  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const deleteProduct = async () => {
    try {
      const response = await deleteProductApi(deleteId);
      if (response.data.success === true) {
        navigate(-1);
        setDeleteId(null);
        setIsOpenDelete(false);
      }
      if (response.data) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        setShowSnackbar(true);
      }
    } catch (err) {
      console.error("Error deleting product:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);
  const handleStatusUpdate = async (newStatus) => {
    if (!product) return;
    setIsStatusUpdating(true);
    try {
      const response = await updateProductStatusApi(product.id, {
        status: newStatus,
      });
      if (response.data && response.data.success) {
        setProduct((prev) => ({ ...prev, status: newStatus }));
      } else {
        console.error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setIsStatusUpdating(false);
    }
  };
  const [dimensionUnit, setDimensionUnit] = useState("");
  const [boxdimensionUnit, setBoxDimensionUnit] = useState("");
  const [customdimensionUnit, setCustomDimensionUnit] = useState("");

  const [singleDimension, setSingleDimension] = useState({});
  const [boxDimension, setBoxDimension] = useState({});
  const [customDimension, setCustomDimension] = useState({});
  useEffect(() => {
    const fetch = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
      try {
        const res = await getProductEditApi(id);
        if (res?.data?.success) {
          setProduct(res.data.products || null);
          const single = res.data.products.uoms?.find((u) => u.uom_name === "Single") || {};
          const box = res.data.products.uoms?.find((u) => u.uom_name === "Box") || {};
          const custom = res.data.products.uoms?.find((u) => u.uom_name === "Custom") || {};
          setDimensionUnit(single.measurement_type ?? "");
          setBoxDimensionUnit(box.measurement_type ?? "");
          setCustomDimensionUnit(custom.measurement_type ?? "");

          setSingleDimension({
            length: single.length ?? "",
            breadth: single.width ?? "",
            height: single.height ?? "",
            quantity: single.quantity ?? "",
            price: single.price ?? "",
          });

          setBoxDimension({
            length: box.length ?? "",
            breadth: box.width ?? "",
            height: box.height ?? "",
            quantity: box.quantity ?? "",
            price: box.price ?? "",
          });

          setCustomDimension({
            length: custom.length ?? "",
            breadth: custom.width ?? "",
            height: custom.height ?? "",
            quantity: custom.quantity ?? "",
            price: custom.price ?? "",
          });
        }
      } catch (err) {
        console.error("fetch product error", err);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [id]);

  if (loading) {
    return (
      <div className="d-flex" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
        <Sidebar currentfile="Product" />
        <LoaderModal show={true} />
      </div>
    );
  }

  if (!product) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <p>Product not found.</p>
      </div>
    );
  }

  const images = product.product_attachments || product.images || product.product_images || [];

  return (
    <>
      {" "}
      <LoaderModal show={isLoading} />
      <DeleteModal
        title={"product"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false);
          setDeleteId(null);
        }}
        onDelete={deleteProduct}
      />
      <div className="d-flex" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
        <Sidebar currentfile="Product" />
        <div
          style={{
            width: "calc(100vw - 80px)",
            overflowY: "auto",
            height: "100vh",
          }}
        >
          <Navbar pageTitle="Product" />
          <div className="p-3">
            <div className="bg-white rounded shadow-sm p-3 mb-3 d-flex justify-content-between align-items-start">
              <div className="d-flex gap-3 align-items-center">
                <Button variant="light" className="rounded-circle d-flex align-items-center justify-content-center border" style={{ width: 40, height: 40 }} onClick={() => navigate(-1)}>
                  <FiChevronLeft size={20} />
                </Button>

                <div className="d-flex gap-3 align-items-center text-start">
                  <div className="rounded d-flex align-items-center justify-content-center" style={{ width: 64, height: 64 }}>
                    <div
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "100px",
                        border: "1px solid #EBEBEB",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ProductIc}
                        alt="vendor"
                        style={{
                          width: "54px",
                          height: "54px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "6px",
                    }}
                  >
                    {/* Title */}
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#1F2D3D",
                      }}
                    >
                      {product.item_name ?? ""}
                    </div>

                    {/* Sub info row */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      {/* Category */}
                      <span style={{ fontSize: "14px", color: "#6B7280" }}>{product.criteria ?? ""}</span>

                      {/* Dot separator */}
                      <span
                        style={{
                          width: "5px",
                          height: "5px",
                          borderRadius: "50%",
                          backgroundColor: "#9CA3AF",
                          display: "inline-block",
                        }}
                      ></span>

                      {/* Badge */}
                      <span
                        style={{
                          backgroundColor: "#EEF4FF",
                          padding: "4px 10px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          color: "#3563E9",
                          fontWeight: "500",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {product.type ?? ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex flex-column align-items-end gap-2">
                <div className="d-flex align-items-center gap-2">
                  {checkPermission("edit_permission") && (
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="white"
                        className="border rounded-pill px-3 py-1 d-flex align-items-center gap-2 fs-13"
                        style={{
                          color: product.status ? "#198754" : "#dc3545",
                        }}
                      >
                        {isStatusUpdating ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <>
                            <span className={`rounded-circle ${product.status ? "bg-success" : "bg-danger"}`} style={{ width: "8px", height: "8px" }}></span>
                            {product.status ? "Active" : "Inactive"}
                          </>
                        )}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handleStatusUpdate(true)}>Active</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleStatusUpdate(false)}>Inactive</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                  {/* <Button
                  variant="primary"
                  className="px-3 py-1 fs-13 rounded"
                  onClick={() =>
                    navigate("/product/create", { state: { id: product.id } })
                  }
                >
                  <FiEdit className="me-1" /> Edit
                </Button> */}

                  <div className="d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3">
                    <div onClick={(e) => e.stopPropagation()}>
                      {(checkPermission("edit_permission") || checkPermission("delete_permission")) && (
                        <Dropdown>
                          <Dropdown.Toggle
                            bsPrefix="custom-toggle"
                            variant="light"
                            id="dropdown-sort"
                            className="d-flex align-items-center justify-content-between rounded-5 bg-white"
                            style={{
                              width: "36px",
                              height: "36px",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <span className="d-flex align-items-center px-1 gap-2">
                              <img src={moreIcon} alt="more" />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              backgroundColor: "white",
                              borderRadius: "8px",
                              border: "1px solid #EBEBEB",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            {checkPermission("edit_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  navigate("/product/create", {
                                    state: { id: id },
                                  });
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                            )}
                            {checkPermission("delete_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  setDeleteId(id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Row className="g-3 mb-3">
              <Col lg={8}>
                <Card className="border-0 shadow-sm mb-3">
                  <Card.Body style={{ padding: 0 }}>
                    <div
                      style={{
                        borderRadius: 12,
                        overflow: "hidden",
                        background: "#FFFFFF",
                      }}
                    >
                      <div
                        className="text-start"
                        style={{
                          padding: "18px 20px",
                          borderBottom: "1px solid transparent",
                        }}
                      >
                        <div className="fs-16 fw-700">Product details</div>
                      </div>

                      <div
                        style={{
                          padding: "18px 20px 22px 20px",
                          //   background: "#FBFDFF",
                        }}
                      >
                        {/* container with two rows (label+icon left, value right) */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 12,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "20px", // spacing between label block and value
                            }}
                          >
                            {/* Left section */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                minWidth: "227px", // ← add this
                              }}
                            >
                              <div
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 8,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <ProduIdIc />
                              </div>

                              <div
                                style={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  color: "#7D8693",
                                }}
                              >
                                Product Id
                              </div>
                            </div>

                            {/* Value */}
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 700,
                                color: "#1F2D3D",
                              }}
                            >
                              {product.item_code ? product.item_code : "-"}
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "20px", // spacing between label block and value
                            }}
                          >
                            {/* Left section */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                minWidth: "227px", // ← add this
                              }}
                            >
                              <div
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 8,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <ProduTyIc />
                              </div>

                              <div
                                style={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  color: "#7D8693",
                                }}
                              >
                                Weight
                              </div>
                            </div>

                            {/* Value */}
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 700,
                                color: "#1F2D3D",
                              }}
                            >
                              {product.weight ? product.weight : "-"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>

                <Card className="border-0 shadow-sm mb-3">
                  <Card.Body>
                    <div className="text-start">
                      <h6 className="fw-bold mb-3">Single Product Dimension</h6>
                      <div
                        style={{
                          display: "flex",
                          gap: 20,
                          alignItems: "stretch",
                          flexWrap: "wrap",
                        }}
                      >
                        {/* left panel: stacked rows with gray background */}
                        <div
                          style={{
                            flex: 1,
                            minWidth: 300,
                            borderRadius: 12,
                            overflow: "hidden",
                            background: "#F7F9FB",
                            boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.02)",
                          }}
                        >
                          {[
                            {
                              label: "LENGTH",
                              value: singleDimension.length ?? 0,
                            },
                            {
                              label: "BREADTH",
                              value: singleDimension.breadth ?? 0,
                            },
                            {
                              label: "HEIGHT",
                              value: singleDimension.height ?? 0,
                            },
                          ].map((row, i) => (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "14px 18px",
                                borderBottom: i < 2 ? "1px solid rgba(0,0,0,0.04)" : "none",
                                background: i % 2 === 0 ? "#F4F7FA" : "#F7F9FB",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 12,
                                  color: "#7D8693",
                                  fontWeight: 600,
                                }}
                              >
                                {row.label}
                              </div>
                              <div
                                style={{
                                  fontSize: 14,
                                  color: "#1F2D3D",
                                  fontWeight: 700,
                                }}
                              >
                                {row.value ? `${row.value}${dimensionUnit ? `(${dimensionUnit})` : ""}` : "-"}
                              </div>
                            </div>
                          ))}
                        </div>
                        {/* right panel: quantity & price boxes */}
                        <div
                          style={{
                            width: 260,
                            display: "flex",
                            flex: 1,
                            flexDirection: "column",
                            gap: 12,
                          }}
                        >
                          <div
                            style={{
                              borderRadius: 12,
                              padding: "12px 16px",
                              background: "#FFFFFF",
                              border: "1px solid #E9EEF3",
                              minHeight: 64,
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                color: "#7D8693",
                                fontWeight: 600,
                              }}
                            >
                              QUANTITY
                            </div>
                            <div
                              style={{
                                fontSize: 16,
                                color: "#1F2D3D",
                                fontWeight: 700,
                                marginTop: 6,
                              }}
                            >
                              {singleDimension.quantity ?? 0}
                            </div>
                          </div>

                          <div
                            style={{
                              borderRadius: 12,
                              padding: "12px 16px",
                              background: "#FFFFFF",
                              border: "1px solid #E9EEF3",
                              minHeight: 64,
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                color: "#7D8693",
                                fontWeight: 600,
                              }}
                            >
                              PRICE
                            </div>
                            <div
                              style={{
                                fontSize: 16,
                                color: "#1F2D3D",
                                fontWeight: 700,
                                marginTop: 6,
                              }}
                            >
                              {singleDimension.price ?? 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
                <Card className="border-0 shadow-sm mb-3">
                  <Card.Body>
                    <div className="text-start">
                      <h6 className="fw-bold mb-3">Box Product Dimension</h6>
                      <div
                        style={{
                          display: "flex",
                          gap: 20,
                          alignItems: "stretch",
                          flexWrap: "wrap",
                        }}
                      >
                        {/* left panel: stacked rows with gray background */}
                        <div
                          style={{
                            flex: 1,
                            minWidth: 300,
                            borderRadius: 12,
                            overflow: "hidden",
                            background: "#F7F9FB",
                            boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.02)",
                          }}
                        >
                          {[
                            {
                              label: "LENGTH",
                              value: boxDimension.length ?? 0,
                            },
                            {
                              label: "BREADTH",
                              value: boxDimension.breadth ?? 0,
                            },
                            {
                              label: "HEIGHT",
                              value: boxDimension.height ?? 0,
                            },
                          ].map((row, i) => (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "14px 18px",
                                borderBottom: i < 2 ? "1px solid rgba(0,0,0,0.04)" : "none",
                                background: i % 2 === 0 ? "#F4F7FA" : "#F7F9FB",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 12,
                                  color: "#7D8693",
                                  fontWeight: 600,
                                }}
                              >
                                {row.label}
                              </div>
                              <div
                                style={{
                                  fontSize: 14,
                                  color: "#1F2D3D",
                                  fontWeight: 700,
                                }}
                              >
                                {row.value ? `${row.value}${boxdimensionUnit ? `(${boxdimensionUnit})` : ""}` : "-"}
                              </div>
                            </div>
                          ))}
                        </div>
                        {/* right panel: quantity & price boxes */}
                        <div
                          style={{
                            width: 260,
                            display: "flex",
                            flex: 1,
                            flexDirection: "column",
                            gap: 12,
                          }}
                        >
                          <div
                            style={{
                              borderRadius: 12,
                              padding: "12px 16px",
                              background: "#FFFFFF",
                              border: "1px solid #E9EEF3",
                              minHeight: 64,
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                color: "#7D8693",
                                fontWeight: 600,
                              }}
                            >
                              QUANTITY
                            </div>
                            <div
                              style={{
                                fontSize: 16,
                                color: "#1F2D3D",
                                fontWeight: 700,
                                marginTop: 6,
                              }}
                            >
                              {boxDimension.quantity ?? 0}
                            </div>
                          </div>

                          <div
                            style={{
                              borderRadius: 12,
                              padding: "12px 16px",
                              background: "#FFFFFF",
                              border: "1px solid #E9EEF3",
                              minHeight: 64,
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                color: "#7D8693",
                                fontWeight: 600,
                              }}
                            >
                              PRICE
                            </div>
                            <div
                              style={{
                                fontSize: 16,
                                color: "#1F2D3D",
                                fontWeight: 700,
                                marginTop: 6,
                              }}
                            >
                              {boxDimension.price ?? 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
                <Card className="border-0 shadow-sm mb-3">
                  <Card.Body>
                    <div className="text-start">
                      <h6 className="fw-bold mb-3">Custom Product Dimension</h6>
                      <div
                        style={{
                          display: "flex",
                          gap: 20,
                          alignItems: "stretch",
                          flexWrap: "wrap",
                        }}
                      >
                        {/* left panel: stacked rows with gray background */}
                        <div
                          style={{
                            flex: 1,
                            minWidth: 300,
                            borderRadius: 12,
                            overflow: "hidden",
                            background: "#F7F9FB",
                            boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.02)",
                          }}
                        >
                          {[
                            {
                              label: "LENGTH",
                              value: customDimension.length ?? 0,
                            },
                            {
                              label: "BREADTH",
                              value: customDimension.breadth ?? 0,
                            },
                            {
                              label: "HEIGHT",
                              value: customDimension.height ?? 0,
                            },
                          ].map((row, i) => (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "14px 18px",
                                borderBottom: i < 2 ? "1px solid rgba(0,0,0,0.04)" : "none",
                                background: i % 2 === 0 ? "#F4F7FA" : "#F7F9FB",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 12,
                                  color: "#7D8693",
                                  fontWeight: 600,
                                }}
                              >
                                {row.label}
                              </div>
                              <div
                                style={{
                                  fontSize: 14,
                                  color: "#1F2D3D",
                                  fontWeight: 700,
                                }}
                              >
                                {row.value ? `${row.value}${customdimensionUnit ? `(${customdimensionUnit})` : ""}` : "-"}
                              </div>
                            </div>
                          ))}
                        </div>
                        {/* right panel: quantity & price boxes */}
                        <div
                          style={{
                            width: 260,
                            display: "flex",
                            flex: 1,
                            flexDirection: "column",
                            gap: 12,
                          }}
                        >
                          <div
                            style={{
                              borderRadius: 12,
                              padding: "12px 16px",
                              background: "#FFFFFF",
                              border: "1px solid #E9EEF3",
                              minHeight: 64,
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                color: "#7D8693",
                                fontWeight: 600,
                              }}
                            >
                              QUANTITY
                            </div>
                            <div
                              style={{
                                fontSize: 16,
                                color: "#1F2D3D",
                                fontWeight: 700,
                                marginTop: 6,
                              }}
                            >
                              {customDimension.quantity ?? 0}
                            </div>
                          </div>

                          <div
                            style={{
                              borderRadius: 12,
                              padding: "12px 16px",
                              background: "#FFFFFF",
                              border: "1px solid #E9EEF3",
                              minHeight: 64,
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                color: "#7D8693",
                                fontWeight: 600,
                              }}
                            >
                              PRICE
                            </div>
                            <div
                              style={{
                                fontSize: 16,
                                color: "#1F2D3D",
                                fontWeight: 700,
                                marginTop: 6,
                              }}
                            >
                              {customDimension.price ?? 0}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={4}>
                <Card className="border-0 shadow-sm mb-3">
                  <Card.Body className="text-start">
                    <h6 className="fw-bold mb-3">Product Images</h6>
                    <div className="d-flex flex-wrap gap-2">
                      {images && images.length ? (
                        images.map((img, idx) => (
                          <div
                            key={idx}
                            style={{
                              width: 72,
                              height: 72,
                              borderRadius: 8,
                              overflow: "hidden",
                              background: "#F7F9FB",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              className="img-fluid"
                              src={typeof img === "string" ? img : img.file_path || img.url || img.path}
                              alt={`img-${idx}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        ))
                      ) : (
                        <div className="text-muted">No images</div>
                      )}
                    </div>
                  </Card.Body>
                </Card>

                <Card className="border-0 shadow-sm">
                  <Card.Body className="text-start">
                    <h6 className="fw-bold mb-3">Description</h6>
                    <div className="text-muted">{product.details || "-"}</div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={() => setShowSnackbar(false)} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default ProductView;
